"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _loader = require("./loader.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const loaderAnimation = (0, _styledComponents.keyframes)`
  0%, 80%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
`;

const getDimentions = size => {
  let width;
  let marginRight;

  switch (size) {
    case "medium":
      width = "16px";
      marginRight = "8px";
      break;

    case "large":
      width = "20px";
      marginRight = "8px";
      break;

    default:
      width = "12px";
      marginRight = "6px";
  }

  return `
  width: ${width};
  height: ${width};
  margin-right: ${marginRight};
  `;
};

const StyledLoaderSquare = _styledComponents.default.div`
  ${({
  theme,
  size,
  isInsideButton,
  isActive
}) => (0, _styledComponents.css)`
    animation: ${loaderAnimation} 1s infinite ease-in-out both;
    background-color: ${theme.colors.primary};
    display: inline-block;
    ${getDimentions(size)}

    ${isInsideButton && (0, _styledComponents.css)`
      background-color: ${isActive ? theme.colors.white : theme.colors.border};
    `}

    &:nth-of-type(1) {
      animation-delay: 0s;
    }

    &:nth-of-type(2) {
      animation-delay: 0.2s;
    }

    &:nth-of-type(3) {
      animation-delay: 0.4s;
      margin-right: 0px;
    }
  `}
`;
StyledLoaderSquare.defaultProps = {
  theme: _base.default,
  size: "small",
  isInsideButton: false,
  isActive: true
};
StyledLoaderSquare.propTypes = {
  size: _propTypes.default.oneOf(_loader.LOADER_SIZES),
  isInsideButton: _propTypes.default.bool,
  isActive: _propTypes.default.bool
};
var _default = StyledLoaderSquare;
exports.default = _default;